// extracted by mini-css-extract-plugin
module.exports = {"viewportXS":"0px","viewportS":"576px","viewportM":"768px","viewportL":"992px","viewportXl":"1200px"};